// @flow
export const cookieOptions = {
    encoding: 'none',
    ttl: 1000 * 60 * 60 * 24 * 30,
    path: '/',
    isSecure: false,
    isHttpOnly: false
};

export const HAS_DOCUMENT_COOKIE =
    typeof document === 'object' && typeof document.cookie === 'string';

export type HapiCookieState = {
    name: string,
    data: string,
    options?: any
};

type CookieName = 'ha-state-prst' | 'ha-trip-prst' | 'eu-site';

const writeCookie = (name: CookieName, value: mixed) => {
    if (!HAS_DOCUMENT_COOKIE) {
        return;
    }
    const expireTime = new Date();
    expireTime.setTime(expireTime.getTime() + 30 * 24 * 60 * 60 * 1000);
    const cookie = [
        name,
        '=',
        encodeURIComponent(JSON.stringify(value)),
        ';expires=',
        expireTime.toUTCString(),
        '; path=/;'
    ].join('');

    document.cookie = cookie;
};

const matchCookie = (name: CookieName, source: string): Object => {
    const regexValue = '=([^;]+)';
    let regexArray = source.match(new RegExp(name + regexValue));
    let result = {};
    if (regexArray && regexArray.length > 0) {
        result = JSON.parse(decodeURIComponent(regexArray[1]));
    } else {
        result = {};
    }
    return result;
};

const readCookie = (name: CookieName, cookieSource?: ?string): Object => {
    if (!cookieSource) {
        cookieSource = HAS_DOCUMENT_COOKIE ? document.cookie : '';
    }
    let result;
    try {
        result = matchCookie(name, cookieSource);
    } catch (err) {
        result = {};
    }
    return result;
};

function deleteCookie(name: CookieName) {
    if (!HAS_DOCUMENT_COOKIE) {
        return;
    }
    document.cookie = [
        name,
        '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/'
    ].join('');
}

export default {writeCookie, deleteCookie, readCookie};
